import React, { useState, useContext } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// import 'date-fns';
// import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { StoreContext } from "../../../store/Provider";
import TextField from "@mui/material/TextField";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import moment from "moment";
import "./modal.css";

function AddFilter() {
  const [modeValue, setModeValue] = useState("");
  const [dateTypeValue, setDateTypeValue] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const context = useContext(StoreContext);

  const handleChangeDateFrom = (date) => {
    setDateFrom(date);
  };

  const handleChangeDateTo = (date) => {
    setDateTo(date);
  };

  const handleChangemode = (event) => {
    setModeValue(event.target.value);
  };

  const handleChangeDateType = (event) => {
    setDateTypeValue(event.target.value);
  };

  const resetFilters = () => {
    setModeValue("");
    setDateTypeValue("");
    setDateFrom(null);
    setDateTo(null);
  };

  const filterSearch = () => {
    context.setSearchResultView(true);
    context.setShipmentId("");
    context.setSearchInputValue("");
    context.setAdvFilterCall(true);
    context.handleModalClose();
    let firstDate = moment(dateFrom).format("MM/DD/YYYY");
    let lastDate = moment(dateTo).format("MM/DD/YYYY");
    let finaldate = `${firstDate} - ${lastDate}`;
    console.log(dateTypeValue, finaldate);
    if (dateTypeValue === "ETA") {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        eta: finaldate,
        etd: ""
      });
    } else if (dateTypeValue === "ETD") {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        etd: finaldate,
        eta: ""
      });
    } else {
      context.setAdvSearchFilter({
        tranportMode: modeValue,
        etd: "",
        eta: ""
      });
    }
  };

  return (
    <div className="filterModeComponent searchFilterShipment">
      <div className="modalHeading">
        <h6>Apply Filters</h6>
        <CloseIcon className="pointer" onClick={context.handleModalClose} />
      </div>
      <div className="filterModalBody">
        <RadioGroup
          className="modeFilter"
          name="filterMode"
          value={modeValue}
          onChange={handleChangemode}
        >
          <FormControlLabel
            value="AIR"
            control={<Radio color="primary" />}
            label="Air Only"
          />
          <FormControlLabel
            value="SEA"
            control={<Radio color="primary" />}
            label="Sea Only"
          />
        </RadioGroup>
        <RadioGroup
          className="dateFilter"
          name="dateFilter"
          value={dateTypeValue}
          onChange={handleChangeDateType}
        >
          <FormControlLabel
            value="ETA"
            control={<Radio color="primary" />}
            label="ETA"
          />
          <FormControlLabel
            value="ETD"
            control={<Radio color="primary" />}
            label="ETD"
          />
        </RadioGroup>
        {dateTypeValue === "" ? null : (
          <>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileDatePicker
                className="etdFilter"
                maxDate={new Date()}
                clearable
                id="etdFilter"
                placeholder="Date from"
                format="dd/MM/yyyy"
                value={dateFrom}
                onChange={handleChangeDateFrom}
                renderInput={(params) => (
                  <TextField variant="filled" size="small" {...params} />
                )}
              />
              <MobileDatePicker
                className="etaFilter"
                minDate={dateFrom}
                clearable
                placeholder="Date to"
                format="dd/MM/yyyy"
                value={dateTo}
                onChange={handleChangeDateTo}
                renderInput={(params) => (
                  <TextField variant="filled" size="small" {...params} />
                )}
              />
            </LocalizationProvider>
          </>
        )}
      </div>
      <div className="modalFooter mt-3">
        <Button variant="contained" onClick={resetFilters}>
          Reset
        </Button>
        <Button variant="contained" onClick={filterSearch}>
          Apply
        </Button>
      </div>
    </div>
  );
}

export default AddFilter;
